class LurenRail extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.track = this.querySelector('[data-rail-track]');
    this.prev = this.querySelector('[data-rail-prev]');
    this.next = this.querySelector('[data-rail-next]');
    if (!this.track || !this.prev || !this.next) return;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.prev.addEventListener('click', () => this.go(-1), { signal });
    this.next.addEventListener('click', () => this.go(1), { signal });
    this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.track);
    this.update();
  }
  go(direction) {
    const slide = this.track.firstElementChild;
    if (!slide) return;
    const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
    const page = Math.max(1, Math.floor((this.track.clientWidth + 2) / step)) * step;
    this.track.scrollBy({ left: direction * page, behavior: this.motion.matches ? 'auto' : 'smooth' });
  }
  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    this.prev.hidden = scrollLeft <= 2;
    this.next.hidden = scrollLeft + clientWidth >= scrollWidth - 2;
  }
  disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
}
if (!customElements.get('luren-rail')) customElements.define('luren-rail', LurenRail);
